import React from 'react';
import { getPageContent, useAppActions, useAppState } from '../../context';
import {
  ActivityGroupView,
  isPageReferenceActivity,
  isPageReferenceActivityGroup,
  PageReferenceActivity,
} from '@gkn-ili/views/dist/OrderDocumentation';
import { getParentPageReference } from '../../utils/orderDocumentationHelpers';

import { Home12Filled, Home12Regular } from '@fluentui/react-icons';
import { makeStyles, Toolbar, ToolbarButton } from '@fluentui/react-components';

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },
});

export default function AppActivityGroupNav(): JSX.Element {
  const styles = useStyles();
  const appState = useAppState();
  const appActions = useAppActions();

  const groupActivityKey = isPageReferenceActivity(appState.activePage)
    ? getParentPageReference(appState.activePage)
    : isPageReferenceActivityGroup(appState.activePage)
      ? appState.activePage
      : null;

  const groupActivityPage = groupActivityKey
    ? (getPageContent(appState.orderView, groupActivityKey) as ActivityGroupView)
    : null;

  const activeIndex = groupActivityPage
    ? isPageReferenceActivityGroup(appState.activePage)
      ? -1
      : Object.keys(groupActivityPage.activities).findIndex(
          (activityKey) => activityKey === (appState.activePage as PageReferenceActivity).activityKey,
        )
    : null;

  return groupActivityPage ? (
    <div className={styles.root}>
      <Toolbar>
        <ToolbarButton
          onClick={groupActivityKey ? () => appActions.updateActivePage(groupActivityKey) : undefined}
          icon={activeIndex === -1 ? <Home12Filled /> : <Home12Regular />}
        />
        {Object.keys(groupActivityPage.activities).map((key, i) => (
          <ToolbarButton
            key={key}
            onClick={
              groupActivityKey
                ? () => appActions.updateActivePage({ ...groupActivityKey, activityKey: key })
                : undefined
            }
            icon={
              activeIndex === i ? (
                <svg width="10px" height="4px">
                  <rect width="10px" height="4px" x="0px" y="0px" rx="2px" ry="2px" />
                </svg>
              ) : (
                <svg width="10px" height="4px">
                  <rect width="4px" height="4px" x="3px" y="0px" rx="2px" ry="2px" />
                </svg>
              )
            }
          />
        ))}
      </Toolbar>
    </div>
  ) : (
    <></>
  );
}
